export enum RfpStatus {
  Draft = "Draft",
  Distributed = "Distributed",
  InReview = "InReview",
  AnalyticalReview = "AnalyticalReview",
  Completed = "Completed",
}
